import { ReportListFilter } from '../shared/report-list-filter.model';
import * as reportActions from './report.actions';

export interface ReportState {
  reportList: {
    showing: string;
    filter: ReportListFilter;
    reportListSelectedRow: any;
    engineVersion: number;
  };
  generate: {
    reportName: string;
    requestId: string;
    message: string;
    format: string;
    params: any[];
  };
}

export const initialState: ReportState = {
  reportList: {
    showing: 'grid',
    filter: null,
    reportListSelectedRow: null,
    engineVersion: null,
  },
  generate: {
    reportName: null,
    requestId: null,
    message: null,
    format: null,
    params: null,
  },
};

export function reportReducer(state = initialState, action: reportActions.ReportActions) {
  switch (action.type) {
    case reportActions.REPORT_LIST_INIT:
      return initialState;

    case reportActions.REPORT_LIST_SET_FILTER:
      return {
        ...state,
        reportList: {
          ...state.reportList,
          filter: action.filter,
        },
      };

    case reportActions.REPORT_LIST_CLEAR_FILTER:
      return {
        ...state,
        reportList: {
          ...state.reportList,
          filter: null,
        },
      };

    case reportActions.REPORT_LIST_SET_SHOWING:
      return {
        ...state,
        reportList: {
          ...state.reportList,
          showing: action.area,
        },
      };

    case reportActions.REPORT_LIST_SELECT_ROW:
      return {
        ...state,
        reportList: {
          ...state.reportList,
          reportListSelectedRow: action.row,
        },
      };

    case reportActions.REPORT_LIST_REQUEST_DATA:
    case reportActions.REPORT_LIST_CLEAR_SELECT_ROW:
    case reportActions.REPORT_RUN_INIT_DIALOG:
      return {
        ...state,
        generate: {
          ...initialState.generate,
        },
      };

    case reportActions.REPORT_RUN_SET_VERSION:
      return {
        ...state,
        reportList: {
          ...state.reportList,
          engineVersion: action.version,
        },
      };

    case reportActions.REPORT_RUN_INIT_PARAMS:
      return {
        ...state,
        generate: {
          ...initialState.generate,
          reportName: action.data.reportName,
          message: action.data.message,
          params: action.data.params,
          requestId: action.data.requestId,
        },
      };

    case reportActions.REPORT_RUN_UPDATE_PARAMS:
      return {
        ...state,
        generate: {
          ...state.generate,
          message: action.data.message,
          params: action.data.params,
          format: action.data.format,
        },
      };

    default:
      return state;
  }
}
